module.exports = __webpack_public_path__ + "img/garage.8783e695.svg";